import React from 'react';
import { Typography, List, ListItem, ListItemText, Grid2 as Grid, Box } from '@mui/material';
import { Facility, Hours } from '../../models/Hours';
import { facility } from '../../models/DashboardInformation';

interface FacilityInformationProps {
  data: facility | null;
}
const FacilityHours: React.FC<FacilityInformationProps> = ({ data }) => {
  if (!data) {
    return <div>
      <Typography mb={2} variant="h3" color="text.secondary">Facility Hours</Typography>
      <Typography color="text.secondary"> No data Found </Typography>
    </div>;
  }
  const facility: Facility = data.office_hours;
  const facilityOfz: Facility = data.access_hours;
  const formatTime = (timeString: string): string => {
    const [time, modifier] = timeString.split(/(am|pm)/);
    let [hours, minutes] = time.split(':').map(Number);
    if (modifier === 'pm' && hours < 12) {
      hours += 12;
    } else if (modifier === 'am' && hours === 12) {
      hours = 0;
    }
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
    return `${formattedHours}:${minutesStr}${modifier}`;
  };
  const getFormattedTimeRange = (dayHours: Hours): string => {
    if (dayHours.is_open_24_hours) {
      return 'Open 24 Hours';
    }
    if (!dayHours.enabled) {
      return 'Closed';
    }
    if (!dayHours.open || !dayHours.close) {
      return 'N/A';
    }
    const openFormatted = formatTime(dayHours.open);
    const closeFormatted = formatTime(dayHours.close);
    return `${openFormatted} - ${closeFormatted}`;
  };
  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  return (
    <Box p={2} border={'1px solid #000'} borderColor={'divider'} height={'100%'}>
      <Typography variant="h3" color="text.secondary">Facility Hours</Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography mb={1.2} variant='h4'>OFFICE</Typography>
          <List>
            {daysOfWeek.map((day) => {
              const dayHours = facility[day];
              return (
                <ListItem key={day}>
                  <ListItemText
                    primary={day.charAt(0).toUpperCase() + day.slice(1)}
                    secondary={dayHours ? getFormattedTimeRange(dayHours) : 'N/A'}
                  />
                </ListItem>
              );
            })}
          </List>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography mb={1.2} variant='h4'>ACCESS</Typography>
          <List>
            {daysOfWeek.map((day) => {
              const dayHours = facilityOfz[day];
              return (
                <ListItem key={day}>
                  <ListItemText
                    primary={day.charAt(0).toUpperCase() + day.slice(1)}
                    secondary={dayHours ? getFormattedTimeRange(dayHours) : 'N/A'}
                  />
                </ListItem>
              );
            })}
          </List>
        </Grid>
      </Grid>
    </Box>

  );

};

export default FacilityHours;
